import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-curd-machine-resource',
  templateUrl: './curd-machine-resource.component.html',
  styleUrls: ['./curd-machine-resource.component.css']
})
export class CurdMachineResourceComponent implements OnInit {
  resourceForm!: FormGroup;
  mode: 'add' | 'edit' | 'view' = 'add'; // switch this as needed
  resourceId: string | null = null;

  machineConditions = ['Active', 'Under Maintenance', 'Idle'];
  statusOptions = ['Idle till date', 'Reserved till date', 'On job till date', 'Maintenance till date'];
  capacities = ['12t', '21t', '32t', 'Others'];

  constructor(private route: ActivatedRoute, private fb: FormBuilder) {
    this.resourceForm = this.fb.group({
      company: this.fb.group({
        name: ['', Validators.required],
        address: ['', Validators.required],
        logo: ['']
      }),
      typeOfMachine: ['', Validators.required],
      contactPerson: ['', Validators.required],
      supervisor: ['', Validators.required],
      mobileNumber: ['', [Validators.required, Validators.pattern(/^[6-9]\d{9}$/)]],
      email: ['', [Validators.required, Validators.email]],
      currentLocation: ['', Validators.required],
      capacity: ['', Validators.required],
      make: [''],
      purchaseDate: ['', Validators.required],
      maintenanceDate: [''],
      lastMaintenanceDate: [''],
      machineCondition: ['', Validators.required],
      trackerNumber: [''],
      history: [''],
      status: ['', Validators.required],
      inspectionEngineer: [''],
      engineerLocation: [''],
      engineerEmail: ['', [Validators.email]],
      engineerMobile: ['', [Validators.pattern(/^[6-9]\d{9}$/)]]
    });
  }

  ngOnInit(): void {
    // Get mode from route data
    this.mode = this.route.snapshot.data['mode'] || 'add';

    // Get ID for edit/view
    this.resourceId = this.route.snapshot.paramMap.get('id');
    this.initForm();
    if (this.mode === 'edit' || this.mode === 'view') {
      const mockData = {
        company: {
          name: 'Example Co.',
          address: '123 Tech Park',
          logo: ''
        },
        typeOfMachine: 'Excavator',
        contactPerson: 'John Doe',
        supervisor: 'Jane Smith',
        mobileNumber: '9876543210',
        email: 'contact@example.com',
        currentLocation: '12.9716° N, 77.5946° E',
        capacity: '21t',
        make: 'Apolo',
        purchaseDate: new Date(),
        maintenanceDate: new Date(),
        lastMaintenanceDate: new Date(),
        machineCondition: 'Active',
        trackerNumber: 'TRK123456',
        history: 'Operational in past 3 months',
        status: 'On job till date',
        inspectionEngineer: 'Engineer Name',
        engineerLocation: 'Site A',
        engineerEmail: 'engineer@example.com',
        engineerMobile: '9123456789'
      };
      this.resourceForm.patchValue(mockData);

    }
    // Sample data for viewing

      if (this.mode === 'view') {
      this.resourceForm.disable();
    }

  }

  initForm(): void {
    this.resourceForm = this.fb.group({
      company: this.fb.group({
        name: ['', Validators.required],
        address: ['', Validators.required],
        logo: ['']
      }),
      typeOfMachine: ['', Validators.required],
      contactPerson: ['', Validators.required],
      supervisor: ['', Validators.required],
      mobileNumber: ['', [Validators.required, Validators.pattern(/^[6-9]\d{9}$/)]],
      email: ['', [Validators.required, Validators.email]],
      currentLocation: ['', Validators.required],
      capacity: ['', Validators.required],
      make: [''],
      purchaseDate: ['', Validators.required],
      maintenanceDate: [''],
      lastMaintenanceDate: [''],
      machineCondition: ['', Validators.required],
      trackerNumber: [''],
      history: [''],
      status: ['', Validators.required],
      inspectionEngineer: [''],
      engineerLocation: [''],
      engineerEmail: ['', [Validators.email]],
      engineerMobile: ['', [Validators.pattern(/^[6-9]\d{9}$/)]]
    });

  }

  setMode(mode: 'add' | 'edit' | 'view'): void {
    this.mode = mode;
    if (mode === 'view') {
      this.resourceForm.disable();
    } else {
      this.resourceForm.enable();
    }
  }

  onSubmit(): void {
    if (this.resourceForm.valid) {
      console.log('Form Submitted', this.resourceForm.value);
      // this.setMode('view');
    } else {
      this.resourceForm.markAllAsTouched();
    }
  }
}
